// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1cIEg","select":"Header_select__3V23a","clinic":"Header_clinic__siDt1"};